<template>
  <v-dialog persistent v-model="open" class="opa" max-width="800">
    <v-card class="px-5 px-sm-16 px-md-16 px-lg-16 px-xl-16 py-5 rounded-xl secondaryBackground">
      <v-card-title class="pb-3">
        <v-row>
          <v-col sm="12" class="justify-center d-flex">
            <img
              alt="Logo"
              width="180"
              class="rounded-0 text-center"
              :src="require('@/assets/svg/logo.svg')"
            />
          </v-col>
        </v-row>
        <v-btn icon @click="$emit('close', true)" left>
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </v-card-title>
      <v-divider class="pb-2"></v-divider>
      <v-card-text id="change-email-modal">
        <v-layout row wrap align-center>
          <v-flex>
            <v-row>
              <v-col sm="12" class="justify-center d-flex">
                <img
                  alt="Delete Logo"
                  width="120"
                  class="rounded-0 text-center"
                  :src="require('@/assets/svg/delete.svg')"
                />
              </v-col>
              <v-col sm="12" class="justify-center d-flex">
                <h3>Delete your account?</h3>
              </v-col>
              <v-col sm="12" class="justify-center d-flex">
                <p class="text-center pl-16 pr-16">
                  Are you sure you want to permanently delete your account? This action
                  <b>cannot be undone.</b>
                </p>
              </v-col>
            </v-row>

            <v-form ref="form" :lazy-validation="false">
              <v-row class="justify-center" v-if="errorSummary !== null">
                <v-col col="12" md="7" xl="7" lg="7" sm="7" class="pb-0">
                  <v-alert class="error" id="error" type="info" dense icon="mdi-information-outline"
                    >{{ errorSummary }}
                  </v-alert>
                </v-col>
              </v-row>
            </v-form>
          </v-flex>
        </v-layout>
      </v-card-text>
      <v-card-actions>
        <v-row style="width: 100%">
          <v-col cols="6">
            <v-btn
              block
              depressed
              rounded
              large
              class="neutral800--text font-weight-bold"
              color="neutral"
              outlined
              @click="$emit('close', true)"
              >{{ $t('cancel') }}
            </v-btn>
          </v-col>
          <v-col cols="6">
            <v-btn
              block
              depressed
              rounded
              large
              class="white--text font-weight-bold"
              color="danger"
              @click="deleteProcess()"
              >{{ $t('delete.message') }}
            </v-btn>
          </v-col>
        </v-row>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import EventBus from '@/helpers/event-bus';
import util from '@/mixins/util';
import service from '@/services/profile-service.js';

export default {
  name: 'DeleteAccount',
  props: {
    deleteUser: {
      type: Boolean,
      default: false,
    },
  },
  mixins: [util, service],
  data() {
    return {
      errorSummary: null,
      open: false,
    };
  },
  methods: {
    deleteProcess() {
      console.log('Delete Account');
      EventBus.$emit('waiting', true);
      this.deleteAccount()
        .then(() => {
          EventBus.$emit('snackbar', {
            text: this.$i18n.t('Your account has deleted successfully.'),
          });
          setTimeout(() => {
            this.logout();
          }, '2000');
        })
        .catch(error => {
          console.log(error);
          if (error.response.status === 409) {
            EventBus.$emit('snackbar', {
              text: 'Something went wrong. Please try again later',
              color: 'error',
            });
          }
        })
        .finally(EventBus.$emit('waiting', false));
    },
  },
  watch: {
    deleteUser: {
      handler: function() {
        this.open = this.deleteUser;
      },
      deep: true,
    },
  },
};
</script>

<style scoped></style>
